import React from "react";
import styled from "styled-components";

type Disposition = "normal" | "source" | "ours";

interface Props {
  reason: string;
  disposition: Disposition;
  label?: string;
}

const COLORS: Record<Disposition, { bg: string; text: string }> = {
  normal: { bg: "#e8f5e9", text: "#2e7d32" },
  source: { bg: "#fff3e0", text: "#e65100" },
  ours: { bg: "#ffebee", text: "#c62828" },
};

const formatReason = (reason: string) =>
  reason
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

const ReasonBadge: React.FC<Props> = ({ reason, disposition, label }) => (
  <Badge
    $bg={COLORS[disposition].bg}
    $color={COLORS[disposition].text}
  >
    {label ?? formatReason(reason)}
  </Badge>
);

export default ReasonBadge;

const Badge = styled.span<{ $bg: string; $color: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;